import type { ReactElement } from 'react';
import { translate } from 'src/app/project/features/translate/translate';
import { DEFAULT_DATE_FORMAT } from 'src/app/project/modules/preferences/default-date-format';
import { EDateFormat } from 'src/app/project/shared/enums/date-format.enum';
import { TDateRange } from '../../utils/dateValue';
import DatePicker, { TDatePickerSize } from './DatePicker';

export type TDateRangePickerProps = {
  value: TDateRange;
  onChange: (value: TDateRange) => void;
  dateFormat?: EDateFormat;
  readOnly?: boolean;
  disabled?: boolean;
  locked?: boolean;
  size?: TDatePickerSize;
  id?: string;
};

const DateRangePicker = ({
  value,
  onChange,
  dateFormat = DEFAULT_DATE_FORMAT,
  readOnly = false,
  disabled = false,
  locked = false,
  size = 'md',
  id,
}: TDateRangePickerProps): ReactElement => (
  <DatePicker
    selectionMode="range"
    values={[value.from, value.to]}
    onValuesChange={([from, to]) => onChange({ from, to })}
    placeholders={[translate('start_date'), translate('end_date')]}
    dateFormat={dateFormat}
    readOnly={readOnly}
    disabled={disabled}
    locked={locked}
    size={size}
    id={id}
  />
);

export default DateRangePicker;
